import React, { Component, useState ,useEffect} from 'react';
import { Link } from "react-router-dom";
import Axios from 'axios';
import Config  from "../Helpers/Config";
import TabsComp from '../Shared/TabsComp';
import Tab from 'react-bootstrap/Tab';
import Table from "../Shared/Table";
import Pie from "../Shared/Pie";
import GraphsCard from "./GraphsCard";
import Helpers from "../Helpers/Custom";
import Loader from "../../utils/Loader";

function Bond(props,{payload}) {


    const [data, setData] = useState({});
    const [graphData, setGraphData] = useState({});
    const [loading, setLoading] = useState(false);

    useEffect(() => {
       fetchCashDetails();
    }, [props?.payload])

   const fetchCashDetails = ()=>{
            setLoading(true)
            Axios.get(Config.api("api/portfolio/valuation/"+props.name),{
                params:props?.payload
            })
            .then( (response) => {
                var dataset  = response.data;

               
                var lclgraphData = [];

                dataset?.rows?.forEach((list,i)=>{
                    var obj ={}
                    obj.name = list?.currency?.name ?? "";
                    obj.y = list?.totalRow?.marketValue ?? 0;
                    lclgraphData.push(obj)
                });
                setLoading(false)
                setGraphData(lclgraphData)
                setData(dataset)
               
            })
            .catch((err) => {
                setLoading(false)
            });
   }


    return (
        <div className="mt-5 mb-3">
        <Loader loading={loading}/>
      <h5 className="heading border-0">BOND DETAILS</h5>
      <TabsComp defaultActiveKey="position" id="cash">
          <Tab eventKey="position" title="Position" className="custom-tab-content">
              <Table>
                  <thead>
                      <tr>
                          <th rowSpan="2">Description</th>
                          <th rowSpan="2" >Ccy</th>
                          <th rowSpan="2" className="br-bold">Quantity</th>
                          <th colSpan="2" className="redBg br-bold">In Security Ccy</th>
                          <th colSpan="4" className="yellowBg br-bold">In Valuation Ccy</th>
                          <th rowSpan="2">Unrealized Gain/Loss %</th>
                          <th rowSpan="2">% Total</th>
                          <th rowSpan="2"></th>
                      </tr>
                      <tr>
                          <th className="subTh">Avg Cost</th>
                          <th className="subTh br-bold">Market Price</th>
                          <th className="subTh">Market Value</th>
                          <th className="subTh">Accrued Income</th>
                          <th className="subTh">Market Value Including <br/>
                            Accrued Income</th>
                          <th className="subTh br-bold">Unrealized Gain/Loss</th>
                      </tr>
                  </thead>
                  <tbody>
                      { 
                          data && data.rows ? data.rows.map((row,i)=>(
                              <React.Fragment>
                                  <tr className="bg-gray" key={"row"+i}>
                                      <td colSpan="12">{row?.currency?.name}</td>
                                  </tr>
                              
                                  {
                                      row?.rows.map((list,i)=>(
                                          <tr className="" key={"childrow"+i}>
                                              <td>{list?.bond?.name}</td>
                                              <td>{row.currency.name}</td>
                                              <td  className="text-right">{Helpers.formatNumberComma(list?.qty ?? 0)}</td>
                                              <td  className="text-right">{Helpers.amountFormat(row?.avgCost ?? 0)}</td>
                                              <td  className="text-right">{Helpers.amountFormat(row?.marketPrice ?? 0)}</td>
                                              <td  className="text-right">{Helpers.amountFormat(row?.marketValue ?? 0)}</td>
                                              <td  className="text-right">{Helpers.amountFormat(row?.accruedIncome ?? 0)}</td>
                                              <td  className="text-right">{Helpers.amountFormat(row?.marketValueIncludingAccruedIncome ?? 0)}</td>
                                              <td  className="text-right"> {row?.unrealizedGainLoss ? Helpers.formatNumberComma(row?.unrealizedGainLoss ?? 0) : ""}</td>
                                              <td  className="text-right">{row?.unrealizedGainLossPercentage ? Helpers.formatNumberComma(row?.unrealizedGainLossPercentage ?? 0)+"%" : ""}</td>
                                              <td  className="text-right">{row?.totalPercentage ? Helpers.formatNumberComma(row?.totalPercentage ?? 0)+"%" : ""}</td>
                                              <td>
                                                   <Link to={"/transaction/bonds?id="+list?.bond?.id} state={{ payload: props?.payload,id:list.bond.id}}>{<i class="fa fa-bars"></i>}</Link>
                                              </td>

                                          </tr>
                                      ))
                                  }
                              </React.Fragment>
                          )) 
                          :
                          <tr>
                              <td colspan="12" className="text-center">No data found</td>
                          </tr>
                      }
                      {data?.totalRow && <tr>
                          <td colSpan="12" className="emptyRow"></td>
                      </tr>}
                      {data?.totalRow && <tr>
                          <td colSpan="12" className="emptyRow"></td>
                      </tr>}
                  </tbody>
                  {data?.totalRow && <tfoot>
                      <tr>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td className="text-right">{Helpers.amountFormat(data?.totalRow?.marketPrice ?? 0)}</td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td className="text-right">{data?.totalRow?.totalPercentage ? Helpers.formatNumberComma(data?.totalRow?.totalPercentage ?? 0)+"%" : ""}</td>
                          <td></td>
                      </tr>
                  </tfoot>}
              </Table>
          </Tab>
          {/* <Tab eventKey="charts" title="Charts"  className="custom-tab-content">
              <div className="col-md-6">
                      <GraphsCard title="CASH: CURRENCY ALLOCATION - MARKET VALUE %">
                          <Pie data={graphData} />
                      </GraphsCard>
                </div>
          </Tab> */}
      </TabsComp>
  </div>
    )
}

export default Bond
